/* eslint react/prop-types: 0 */
/* eslint no-unused-vars: 0 */

import React from 'react';
import { Result, Button, Typography } from 'antd';
import { axios } from 'axios';

const ResultPage = ({ status = 'warning', duplicateId = null }) => {
  const { Link } = Typography;
  const resetPassword = ($clientID) => {
    axios.get();
  };
  return (
    // active={this.state.view === 'default'}
    <Result
      status={status === 'FAIL' ? 'warning' : 'success'}
      title={
        status === 'FAIL'
          ? 'Пользователь с таким email уже был зарегистрирован'
          : 'Мы отправили на вашу электронную почту ссылку для подтверждения регистрации'
      }
      subTitle={[
        'Если вы не получили письмо, напишите нам на ',
        <Link key="mailto" mailto="itdep@lanbilling.ru" target="_blank">
          itdep@lanbilling.ru
        </Link>,
        ' или позвоните по номеру ',
        <Link key="phone " href="tel:+74957950677">
          +7 (495) 795-06-77
        </Link>
      ]}
      extra={
        duplicateId &&
        status === 'FAIL' && (
          <Button type="primary" key="console" onClick={resetPassword}>
            Сбросить пароль
          </Button>
        )
      }
    />
  );
};

export default ResultPage;
